export const GET_BROADCASTGAME = "GET_BROADCASTGAME";
export const CREATE_NEW_BROADCASTGAME = "CREATE_NEW_BROADCASTGAME";
export const EDIT_BROADCASTGAME = "EDIT_BROADCASTGAME";
export const DELETE_BROADCASTGAME = "DELETE_BROADCASTGAME";
export const CLOSE_BROADCASTGAME_DIALOG = "CLOSE_BROADCASTGAME_DIALOG";
export const OPEN_BROADCASTGAME_DIALOG = "OPEN_BROADCASTGAME_DIALOG";
export const VIP_SWITCH_BROADCASTGAME = "VIP_SWITCH_BROADCASTGAME";
